module.exports = __webpack_public_path__ + "static/KC5-03947e59c872844507130eb9c8379ab0.png";